@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.batches-list-page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.grid {
  flex-grow: 1;
  width: 100%;
  height: calc(100% ~'-' 42px);
  overflow: auto;
  background-color: @batch-list-page--grid--background-color;
}

.paging-footer {
  min-height: 42px;
  border-top: 1px solid @batch-list-page--paging-footer--border-color;
}

.actions-section {
  display: flex;
  flex-wrap: wrap;
  background-color: @batch-list-page--actions-section--background-color;
  padding: 0 0 15px 5px;
  > button {
    margin-left: 10px;
  }
}
